/** A Breeze project id is a UUID; anything else is a broken or hand-edited link, so it is never sent to the API. */
export const UUID_RE = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

export const isUuid = (value: string | undefined | null): value is string => !!value && UUID_RE.test(value);
